import { inrAmount } from '../../../../../../utils/formatters/inrAmount';
import type { EpfPayment } from '../../../../../../store/dashboard/compliancesBefe/types';
import { EPF_PAYMENT_STATUS_LABELS } from './constants';

export type EpfPaymentTone = 'onTime' | 'delayed' | 'default';

export const formatEmployees = (count: number): string => inrAmount(count);

export const getPaymentTone = (payment: EpfPayment): EpfPaymentTone => {
    if (payment.isDefault) return 'default';
    return (payment.delayInDays ?? 0) > 0 ? 'delayed' : 'onTime';
};

export const formatPaymentStatus = (payment: EpfPayment): string => {
    const tone = getPaymentTone(payment);
    if (tone === 'default') return EPF_PAYMENT_STATUS_LABELS.DEFAULT;
    if (tone === 'onTime') return EPF_PAYMENT_STATUS_LABELS.ON_TIME;
    const days = payment.delayInDays as number;
    return `${days} ${days === 1 ? 'Day' : 'Days'} Delay`;
};
